// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__UPD8c","tyre":"style_tyre__y5Vtf"};